import React from 'react';

// const About = () => (
//   <div className="main-content">
//     <h2>About</h2>
//     <p>The front end course directory lists many of the courses we teach on HTML, CSS, JavaScript and more! Be sure to visit the Teachers section to view a list of our talented teachers. Or visit the Courses section and select a topic -- HTML, CSS, or JavaScript -- to see a list of our courses.</p>
//   </div>
// );

// 21) Now we pass the props argument into the 'About' stateless component method ...

// const About = (props) => (
//   <div className="main-content">
//     <h2>About</h2>
//     <p>The front end course directory lists many of the courses we teach on HTML, CSS, JavaScript and more! Be sure to visit the Teachers section to view a list of our talented teachers. Or visit the Courses section and select a topic -- HTML, CSS, or JavaScript -- to see a list of our courses.</p>
//   </div>
// );

// 22) now we replace the hard coded title with an '{props.title}' expression. See below then go to ((Header.js)) ...

const About = (props) => (
  <div className="main-content">
    <h2>{ props.title }</h2>
    <p>The front end course directory lists many of the courses we teach on HTML, CSS, JavaScript and more! Be sure to visit the Teachers section to view a list of our talented teachers. Or visit the Courses section and select a topic -- HTML, CSS, or JavaScript -- to see a list of our courses.</p>
  </div>
);

export default About;



// WEBPACK FOOTER //
// ./src/components/About.js